import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getCampaigns = async (selectedDomain: string, offset = 0, limit = 5): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
        params: {
            offset, limit
        }
    });
}